import request from '@/utils/request'
// 能量列表
export function energyListData(data) {
  return request({
    url: '/sys/user/list/energy',
    method: 'post',
    data
  })
}